import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, TemplateRef } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
export interface IModalCustomConfig {
  todo: string;
}
@Injectable({ providedIn: 'root' })
export class ModalsService {
  constructor(private dialog: MatDialog) {}

  openModal<T, D>(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: ComponentType<T> | TemplateRef<any>,
    config?: MatDialogConfig<D>,
    customConfig?: IModalCustomConfig,
  ): MatDialogRef<T, D> {
    customConfig;
    const modalRef = this.dialog.open(component, config);
    return modalRef;
  }
}
